
<div class="manger_register_details">
    <app-background></app-background>
    <mat-card class="manger_register_card">
        <div class="manger_register_header"> Manager Sign Up </div>
        <div class="manger_register_header_data">Make your content broadcast easier and simple with sharkify.</div>
        <div class="page_details">
            <div class="form_field">
                <mat-form-field appearance="outline" class="manger_register_form_fields">
                    <mat-label>First Name</mat-label>
                    <input matInput  type="text" [formControl]="FirstName"
                        style="vertical-align: top; margin-left: 5px;">
                    <mat-icon matSuffix style="color: var(--black-shade); margin-right: 5px; vertical-align: top;">person</mat-icon>
                    <mat-error *ngIf="!FirstName.valid">
                        {{getFirstNameError()}}
                    </mat-error>
                </mat-form-field>   
            </div>
            
            
            <div class="form_field">
                <mat-form-field appearance="outline" class="manger_register_form_fields">
                    <mat-label>Last Name</mat-label>
                    <input matInput  type="text" [formControl]="LastName"
                        style="vertical-align: top; margin-left: 5px;">
                    <mat-icon matSuffix style="color: var(--black-shade); margin-right: 5px; vertical-align: top;">person</mat-icon>
                    <mat-error *ngIf="!LastName.valid">
                        {{getLastNameError()}}
                    </mat-error>
                </mat-form-field>
            </div>
            
           
            <div class="form_field">
                <mat-form-field appearance="outline" class="manger_register_form_fields">
                    <mat-label>Mobile Number</mat-label>
                    <input matInput  type="text" [formControl]="MobileNumber"
                        style="vertical-align: top; margin-left: 5px;">
                    <mat-icon matSuffix style="color: var(--black-shade); margin-right: 5px; vertical-align: top;">call</mat-icon>
                    <mat-error *ngIf="!MobileNumber.valid">
                        {{getMobileNumberError()}}
                    </mat-error>
                </mat-form-field>
            </div>
            
            
            <div class="form_field">
                <mat-form-field appearance="outline" class="manger_register_form_fields">
                    <mat-label>Email</mat-label>
                    <input matInput  type="text" [formControl]="Email"
                        style="vertical-align: top; margin-left: 5px;">
                    <mat-icon matSuffix style="color: var(--black-shade); margin-right: 5px; vertical-align: top;">mail</mat-icon>
                    <mat-error *ngIf="!Email.valid">
                        {{getEmailError()}}
                    </mat-error>
                </mat-form-field>
            </div>
           
            
            <div class="form_field">
                <mat-form-field appearance="outline" class="manger_register_form_fields">
                    <mat-label>Password</mat-label>
                    <input matInput  [type]="p_hide ? 'password' : 'text'"
                        [formControl]="Password">
                    <button mat-icon-button matSuffix (click)="p_hide = !p_hide" [attr.aria-label]="'Hide password'"
                        [attr.aria-pressed]="p_hide">
                        <mat-icon style="color: var(--black-shade);">{{p_hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                    </button>
                    <mat-error *ngIf="!Password.valid">
                        {{getPasswordError()}}
                    </mat-error>
                </mat-form-field>
            </div>
            
            
            <div class="form_field">
                <mat-form-field appearance="outline" class="manger_register_form_fields">
                    <mat-label>Confirm Password</mat-label>
                    <input matInput  [type]="c_p_hide ? 'password' : 'text'"
                        [formControl]="ConfirmPassword">
                    <button mat-icon-button matSuffix (click)="c_p_hide = !c_p_hide"
                        [attr.aria-label]="'Hide Confirm password'" [attr.aria-pressed]="c_p_hide">
                        <mat-icon style="color: var(--black-shade);">{{c_p_hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                    </button>
                    <mat-error *ngIf="!ConfirmPassword.valid">
                        {{getConfirmPasswordError()}}
                    </mat-error>
                </mat-form-field>  
            </div>
           
            <div class="submit_button_wrap">
                <button class="manger_register_buttons" type="submit" (click)="onManagerSubmit()">Sign Up</button>
            </div>
            <div class="already_account" style="color: grey;">
                Already have an account ? 
                <span class="sign_in_button" routerLink="/ManagerLogin"> Sign In</span>
            </div>
        </div>
    </mat-card>
</div>